import { Component, Input, SimpleChanges } from '@angular/core';
import { APIResultScheduleInvestorResponse, InvestorScheduleControllerService, ScheduleInvestorResponse, ScheduleInvestorSlotPeriodResponse } from '@ent-regis/entregis-ts-angular';
import { b64toBlob, saveFileBlob } from 'src/app/functions/file.function';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-investor-meeting-schedule',
  templateUrl: './investor-meeting-schedule.component.html',
  styleUrls: ['./investor-meeting-schedule.component.scss']
})
export class InvestorMeetingScheduleComponent {

  @Input() isSentScheduleEmail: boolean = false;
  @Input() contactEmail: string = '';
  
  public now = new Date();
  private personName: string = '';
  eventTypeEnum = ScheduleInvestorResponse.EventTypeEnum;
  scheduleInvestorResponse: ScheduleInvestorResponse = null;
  expandedAttendees = new Set<string>();

  constructor(
    private authService: AuthService,
    private scheduleService: InvestorScheduleControllerService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isSentScheduleEmail'] && changes['isSentScheduleEmail'].currentValue) {
      this.getScheduleInvestorInfo();
      this.personName = this.authService.getName();
    }
  }

  get isThailandFocus(): boolean {
    return this.scheduleInvestorResponse && this.scheduleInvestorResponse.eventType === this.eventTypeEnum.THAILANDFOCUS;
  }

  getScheduleInvestorInfo() {
    this.scheduleService.getMyMeetingScheduleUsingGET().subscribe((res: APIResultScheduleInvestorResponse) => {
      const data = res && res.data ? res.data : null;
      if (!data || !data.slots) {
        this.scheduleInvestorResponse = data;
        return;
      }
      const filteredSlots = data.slots.filter(slot =>
        slot && slot.slotPeriods && slot.slotPeriods.length > 0);

      this.scheduleInvestorResponse = {
        ...data,
        slots: filteredSlots
      };
    });
  }

  get hasScheduleSlots(): boolean {
    return !!(this.scheduleInvestorResponse
      && this.scheduleInvestorResponse.slots
      && this.scheduleInvestorResponse.slots.length);
  }

  get timezone(): string {
    return this.isThailandFocus ? 'UTC +7' : null;
  }

  getSortedAttendees(slotPeriod: ScheduleInvestorSlotPeriodResponse): any[] {
    const attendees = slotPeriod && slotPeriod.attendeeInfos ? [...slotPeriod.attendeeInfos] : [];
    return attendees.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  getMeetingType(slotPeriod: ScheduleInvestorSlotPeriodResponse): string {
    if (!slotPeriod || !slotPeriod.meetingType) {
      return '';
    }
    switch(slotPeriod.meetingType) {
      case ScheduleInvestorSlotPeriodResponse.MeetingTypeEnum.GROUP: return 'Group';
      case ScheduleInvestorSlotPeriodResponse.MeetingTypeEnum.ONEONONE: return '1 on 1';
      case ScheduleInvestorSlotPeriodResponse.MeetingTypeEnum.VIRTUALGROUP: return 'Virtual (Group)';
      default: return slotPeriod.meetingType;
    }
  }

  getMeetingTypeClass(meetingType: ScheduleInvestorSlotPeriodResponse.MeetingTypeEnum): string {
    if (meetingType == ScheduleInvestorSlotPeriodResponse.MeetingTypeEnum.VIRTUALGROUP) return 'badge--meeting-type';
    return '';
  }

  isLoginPerson(speakerName: string): boolean {
    if (!speakerName) {
      return false;
    }

    const normalizedName = speakerName.trim().toLowerCase();
    if (!normalizedName) {
      return false;
    }

    const normalizedPersonName = this.personName.trim().toLowerCase();
    return normalizedName === normalizedPersonName;
  }
    
  downloadPresentation(presentationFileUrl: string): void {
    if (!presentationFileUrl) {
      return;
    }
    window.open(presentationFileUrl, '_blank');
  }
  
  trackByIndex(index: number): number {
    return index;
  }

  downloadPdf() {
    const offset = (new Date().getTimezoneOffset() / -60);
    this.scheduleService.getMeetingSchedulePdfUsingGET(offset).subscribe((result) => {
      const blob = b64toBlob(result.data.data, result.data.fileType);
      saveFileBlob(blob, result.data.fileName);
    });
  }

  isAttendeesExpanded(key: string): boolean {
    return this.expandedAttendees.has(key);
  }

  toggleAttendees(key: string): void {
    if (this.expandedAttendees.has(key)) {
      this.expandedAttendees.delete(key);
    } else {
      this.expandedAttendees.add(key);
    }
  }
}
